import { render, staticRenderFns } from "./EmailMessageCard.vue?vue&type=template&id=aabb8120"
import script from "./EmailMessageCard.vue?vue&type=script&lang=js"
export * from "./EmailMessageCard.vue?vue&type=script&lang=js"
import style0 from "./EmailMessageCard.vue?vue&type=style&index=0&id=aabb8120&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports